import { useCallback, useMemo } from 'react';

import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';

const parse = (value) => {
  const maybeInteger = fromAnyToInteger(value);
  return Number.isSafeInteger(maybeInteger) ? maybeInteger : 0;
};

const useCounter = (init) => {
  const [val, setVal] = useStateWhileMounted(parse(init));

  const inc = useCallback(() => setVal(val + 1), [setVal, val]);
  const dec = useCallback(() => setVal(val - 1), [setVal, val]);

  const set = useCallback((value) => setVal(parse(value)), [setVal]);

  return useMemo(() => ({ val, set, inc, dec }), [val, inc, dec, set]);
};

// noinspection JSUnusedGlobalSymbols
export default useCounter;
